import { Component, OnChanges, Input, ViewChild, NgZone, Output, EventEmitter, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { of, Subject } from 'rxjs';
import { Department } from "../Models/Department"
import { Ward } from "../Models/Ward"
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { TranslateService } from '@ngx-translate/core';
import { DepartmentType } from '../Models/DepartmentType';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'lib-ph-bhp-consumption-filter',
  templateUrl: './ph-bhp-consumption-filter.component.html',
  styleUrls: ['./ph-bhp-consumption-filter.component.css']
})
export class PhBhpConsumptionFilterComponent implements OnInit, OnDestroy {
  singleCard = false;
  @Output() filterRemoved = new EventEmitter<number>();
  @Output() showSubCategories = new EventEmitter<boolean>();
  @Output() filterSaved = new EventEmitter<number>();
  private _filterIndex: number;
  @Input()
  set filterIndex(val: number) {
    this._filterIndex = val;
  }
  get filterIndex() {
    return this._filterIndex;
  }
  @Input() userData;
  @Input() filtersForComp;
  @Input() isDesktop = true;
  @Input() hideProfessionalSubcategory = false;
  @Input() unlockMaxDate = false;
  @Input() evaluationLoaded: boolean;
  @Input() userHasFilter: boolean;
  @Input() isMultiselectReport: boolean = true;
  @ViewChild('chipsDiv', { static: true }) chipsDiv: ElementRef;
  @ViewChild('chipsDivOuter', { static: true }) chipsDivOuter: ElementRef;

  filterFlag: boolean = true;
  visible: boolean = true;
  compareInstitutionFn = this.compareFnFactory('institutionID');
  compareCountryFn = this.compareFnFactory('countryID');
  compareDepartmentFn = this.compareFnFactory('departmentID');
  compareDepartmentTypeFn = this.compareFnFactory('departmentTypeID');
  compareWardFn = this.compareFnFactory('wardID');
  compareEntryFn = this.compareFnFactory('entryId');
  compareFnFactory(prop: string) {
    return (a: any, b: any) => {
      if (a && b) {
        return a[prop] === b[prop];
      }
    };
  }

  roleId;
  range1 = {
    start: new Date(),
    end: new Date()
  }
  range = {
    start: new Date().toUTCString(),
    end: new Date().toUTCString()
  }
  maxDate = new Date()
  minDate: Date = void 0;
  countryList: Array<any>;
  institutionsList: Array<any> = [];
  institutionsListLoaded: Array<any> = [];
  departmentList: Department[];
  departmentTypeList: DepartmentType[];
  wardList: Ward[];
  wardListLoaded: Ward[];
  country: any;
  institution: any;
  ward: any;
  filterName: any;
  department: any;
  departmentType: any;
  setCountry: any = 0;
  setInstitution: any = 0;
  setWard: any = 0;
  setFilterName: any = 0;
  setDepartment: any = 0;
  setDepartmentType: any = 0;
  dateRange: Date[];
  currentYear;
  selectedYear: number;
  previousYears: any[] = [];
  singleInstitution = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  showTrashButton: boolean = false;
  defaultStartDate: Date;
  defaultEndDate: Date;
  setDate: boolean = false;
  showMultiselect: boolean = false;
  multiselectOption: string = 'CONFIGURE.DEPARTMENT';
  entrySelected: any = {};
  entryAllSelectedText: string = 'EVALUATION.All.DEPARTMENTS';
  entryNothingSelected: boolean = false;
  entriesSelected: any[] = [];
  entriesSelectedChips: any[] = [];
  entriesList: any[] = [
    { entryId: 'dept', name: 'CONFIGURE.DEPARTMENT' },
    { entryId: 'deptType', name: 'CONFIGURE.DEPARTMENT_TYPE' },
    { entryId: 'ward', name: 'CONFIGURE.WARD' },
  ];
  showEntries: any[] = this.entriesList;
  // allEntriesChecked: boolean = false;
  exportMultiselect: any = {};
  currentStartDate: Date;
  currentEndDate: Date;
  isNewFilter: boolean = false;
  filterButtonPosition: boolean = false;
  viewMore: boolean = false;
  lessMoreIsVisible: boolean = false;
  selectedEntriesCount: number = 0;
  setyear: any = 0;
  entriesSelectedSubject = new Subject<boolean>();


  constructor(
    private layoutService: PHBHPLayoutPackageService,
    public translate: TranslateService,
    public filtersService: FiltersService
  ) {
    this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') }
    this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
  }

  ngOnInit() {

    this.roleId = this.userData.roleName.roleId;
    // Only set a default filter name when there is no previously set name
    if (!this.setFilterName || (typeof this.setFilterName === 'string' && this.setFilterName.trim() === '')) {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.setFilterName = this.filterName;
    } else {
      this.filterName = this.setFilterName;
    }

    this.currentYear = new Date().getFullYear();
    for (let i = this.currentYear; i >= this.currentYear - 4; i--) {
      this.previousYears.push(i);
    }

    this.isDesktop = this.isDesktop;
    this.setyear = this.currentYear;

    this.loadInstitutions();
    this.filtersService.institutionSubject.subscribe(loaded => {
      this.loadInstitutions();
    })

    this.departmentList = this.filtersService.departmentList;
    if (this.departmentList) {
      this.departmentList = this.departmentList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentName)).localeCompare(this.layoutService.translateText(b.departmentName));
      });
    }

    this.filtersService.departmentListSubject.subscribe(loaded => {
      this.departmentList = this.filtersService.departmentList;
      this.departmentList = this.departmentList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentName)).localeCompare(this.layoutService.translateText(b.departmentName));
      });
    })

    this.departmentTypeList = this.filtersService.departmentTypeList;
    if (this.departmentTypeList) {
      this.departmentTypeList = this.departmentTypeList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentTypeName)).localeCompare(this.layoutService.translateText(b.departmentTypeName));
      });
    }

    this.filtersService.departmentTypeListSubject.subscribe(loaded => {
      this.departmentTypeList = this.filtersService.departmentTypeList;
      this.departmentTypeList = this.departmentTypeList.sort((a, b) => {
        return (this.layoutService.translateText(a.departmentTypeName)).localeCompare(this.layoutService.translateText(b.departmentTypeName));
      });
    });

    this.countryList = this.filtersService.countryList;
    this.filtersService.countryListSubject.subscribe(loaded => {
      this.countryList = this.filtersService.countryList;
    })

    this.wardList = this.filtersService.wardList;
    this.filtersService.wardListSubject.subscribe(loaded => {
      this.wardList = this.filtersService.wardList;
    })

  }

  ngOnDestroy() {
    this.entriesSelectedChips = [];
  }

  loadInstitutions() {
    this.institutionsList = this.filtersService.institutionsList || [];
    this.institutionsList = this.institutionsList.sort((a, b) => {
      return (this.layoutService.translateText(a.institutionName)).localeCompare(this.layoutService.translateText(b.institutionName));
    });
  }

  showFilter(isNewFilter = false) {
    this.filterButtonPosition = false;
    this.singleCard = !this.singleCard;
    this.isNewFilter = isNewFilter;
    // Only set a default name when creating a new filter and no name exists
    if (isNewFilter && (!this.setFilterName || (typeof this.setFilterName === 'string' && this.setFilterName.trim() === ''))) {
      const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.filterName = translatedFilterName;
      this.setFilterName = translatedFilterName;
    } else if (!isNewFilter && (!this.filterName || (typeof this.filterName === 'string' && this.filterName.trim() === ''))) {
      // If opening existing filter but current filterName is empty, preserve setFilterName if available
      if (this.setFilterName && typeof this.setFilterName === 'string' && this.setFilterName.trim() !== '') {
        this.filterName = this.setFilterName;
      } else {
        const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
        this.filterName = translatedFilterName;
        this.setFilterName = translatedFilterName;
      }
    }
    setTimeout(() => {
      this.filterButtonPosition = true;
    }, 320);
  }

  public setInfoFromFilter(filter) {
    this.dateRange = { ...filter.dateRange };
    this.range = { ...filter.range };
    this.range1 = { ...filter.range1 };
    this.defaultStartDate = filter.defaultStartDate;
    this.defaultEndDate = filter.defaultEndDate;
    this.setDate = filter.setDate;
    this.setyear = filter.setyear;
    this.country = filter.country;
    this.setCountry = filter.setCountry;
    this.institution = filter.institution;
    this.setInstitution = filter.setInstitution;
    this.ward = filter.ward;
    this.setWard = filter.setWard;
    
    //Always NAME = 'Filter' + last index +1
    const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    this.filterName = translatedFilterName;
    this.setFilterName = translatedFilterName;

    this.wardList = filter.wardList;
    this.wardListLoaded = filter.wardListLoaded;
    this.department = filter.department;
    this.setDepartment = filter.setDepartment;
    this.departmentType = filter.departmentType;
    this.setDepartmentType = filter.setDepartmentType;
    this.showMultiselect = filter.showMultiselect;
    this.multiselectOption = filter.multiselectOption;
    this.entrySelected = filter.entrySelected;
    this.entryAllSelectedText = filter.entryAllSelectedText;
    this.entryNothingSelected = filter.entryNothingSelected;
    this.entriesSelected = filter.entriesSelected;
    this.entriesSelectedChips = filter.entriesSelectedChips;
    this.entriesList = filter.entriesList;
    this.showEntries = filter.showEntries;
    // this.allEntriesChecked = filter.allEntriesChecked;
    this.exportMultiselect = filter.exportMultiselect;
    this.showFilter(true);
  }

  resetFilter() {
    if (this.setyear != this.currentYear) this.setyear = this.currentYear;
    if (this.setCountry && this.roleId == 1) this.countryRemoved(true);
    if (this.setInstitution) this.institutionRemoved(true);
    if (this.setDepartment) this.departmentRemoved(true);
    if (this.setDepartmentType) this.departmentTypeRemoved(true);
    if (this.setWard) this.wardRemoved(true);
    if (this.showMultiselect) {
        this.multiSelectRemoved();
    }
    this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);

    this.setFilter(true);
  }

  countryRemoved(isManualUpdate = false) {
    this.setCountry = 0;
    this.setInstitution = 0;
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setWard = 0;
    this.onWardChange(0);
    this.onInstitutionChange(0);
    this.setFilter(isManualUpdate);
  }

  institutionRemoved(isManualUpdate = false) {
    if (this.singleInstitution) {
      return;
    }
    this.setInstitution = 0;
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setWard = 0;
    this.onWardChange(0);
    this.onInstitutionChange(0);
    this.setFilter(isManualUpdate);
  }

  departmentRemoved(isManualUpdate = false) {
    this.setDepartment = 0;
    this.onDepartmentChange(0);
    this.setFilter(isManualUpdate);
  }

  departmentTypeRemoved(isManualUpdate = false) {
    this.setDepartmentType = 0;
    this.onDepartmentTypeChange(0);
    this.setFilter(isManualUpdate);
  }

  wardRemoved(isManualUpdate = false) {
    this.setWard = 0;
    this.onWardChange(0);
    this.setFilter(isManualUpdate);
  }

  cancelFilter() {
    if (this.isNewFilter) {
      this.removeNewFilter();
      return;
    }

    if (this.roleId == 1) {
      if (this.setCountry != 0) {
        this.country = this.filtersService.countryList.find((res1) => res1.countryID == this.setCountry.countryID);
      } else {
        this.singleCard = false;
        return;
      }
    } else {
    }
    if (this.setDepartment && this.setDepartment != 0) {
      this.department = this.filtersService.departmentList.find((res1) => res1.departmentID == this.setDepartment.departmentID);
    } else {
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }

    if (this.setFilterName && this.setFilterName != "") {
      this.filterName = this.setFilterName;
    } else {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    }

    if (this.setDepartmentType && this.setDepartmentType != 0) {
      this.departmentType = this.filtersService.departmentTypeList.find((res1) => res1.departmentTypeID == this.setDepartmentType.departmentTypeID);
    } else {
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }

    this.singleCard = false;
  }

  setFilter(isManualUpdate = false) {
    if (!isManualUpdate && this.showMultiselect && this.entriesSelected.filter(entry => entry.selected).length == 0) {
      this.layoutService.showError(this.layoutService.translateText('EVALUATION.FILTERS.SELECT_AT_LEAST_ONE'));
      this.filterButtonPosition = true;
      this.singleCard = true;
      setTimeout(() => {
        this.filterButtonPosition = true;
      },);
      return;
    }

    if (this.country && this.country.countryID && this.country.countryID !== 0) {
      this.setCountry = this.country;
    } else {
      this.setCountry = 0;
      this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
    }

    if (this.institution && this.institution.institutionID && this.institution.institutionID !== 0) {
      this.setInstitution = this.institution;
    } else {
      this.setInstitution = 0;
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    }

    if (this.ward && this.ward.wardID && this.ward.wardID !== 0) {
      this.setWard = this.ward;
    } else {
      this.setWard = 0;
      this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    }

    if (this.department && this.department.departmentID && this.department.departmentID !== 0) {
      this.setDepartment = this.department;
    } else {
      this.setDepartment = 0;
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }

    if (this.departmentType && this.departmentType.departmentTypeID && this.departmentType.departmentTypeID !== 0) {
      this.setDepartmentType = this.departmentType;
    } else {
      this.setDepartmentType = 0;
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }

    if (this.showMultiselect) {
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected && e.entryId !== '-1');
    }

    if (this.filterName) {
      this.setFilterName = this.filterName;
    } else {
      this.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
      this.setFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (this.filterIndex + 1);
    }

    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
    if (!isManualUpdate) {
      this.singleCard = false;
      this.filterSaved.emit();
    }
  }

  onCountryChange(country, loadForSA = false) {
    this.cleanInstitution();
    this.cleanWard();
    this.cleanDepartment();
    if (country == 0) {
      this.country = { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
      return of(null);
    }
    else {
      this.country = country;
    }
    this.layoutService.startLoadingFilter();
    if (loadForSA) {
      return this.filtersService.onCountryChange(this.country.countryID);
    }
    this.filtersService.onCountryChange(this.country.countryID).subscribe(institutions => {
      this.filtersService.filterInstitutions(institutions[0]);
      this.filtersService.institutionSubject.next(true);
      this.filtersService.getWardsByInstitutions();
      this.layoutService.stopLoadingFilter();

    });

  }

  onYearChange(year) {
    this.setyear = year;
  }

  onInstitutionChange(value, hideLoader = true) {
    this.cleanWard();
    this.cleanDepartment();
    this.cleanDepartmentType();
    if (value && value.institutionID) {
      this.institution = value;
      this.setInstitution = value;
      this.loadWardsByInstitution(value.institutionID);
    } else {
      delete this.setInstitution;
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    }
    this.loadMultiFilterWards();
    if (this.showMultiselect) {
      this.entriesSelectedChips = this.entriesSelected.filter(e =>e.selected);
    } else {
      this.entriesSelectedChips = [];
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
    this.layoutService.stopLoadingFilter();
  }


  onWardChange(value) {
    if (value == 0) {
      this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    }
    else {
      this.ward = value;
    }
  }

  onDepartmentChange(value) {
    if (value == 0) {
      this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    }
    else {
      this.department = value;
    }
  }

  onDepartmentTypeChange(value) {
    if (value == 0) {
      this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
    }
    else {
      this.departmentType = value;
    }
  }

  cleanInstitution() {
    this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
  }

  cleanWard() {
    this.wardListLoaded = [];
    this.ward = { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
  }

  cleanDepartment() {
    this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
  }

  cleanDepartmentType() {
    this.departmentType = { departmentTypeName: this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
  }

  loadWardsByInstitution(id) {
    if (this.wardList) {
      this.wardListLoaded = this.wardList.filter(ward => ward.institutionID == id);
      this.wardListLoaded = this.wardListLoaded.sort((a, b) => {
        return (this.layoutService.translateText(a.wardName)).localeCompare(this.layoutService.translateText(b.wardName));
      });
    } else {
      this.filtersService.wardListSubject.subscribe(loaded => {
        this.wardListLoaded = this.wardList.filter(ward => ward.institutionID == id);
        this.wardListLoaded = this.wardListLoaded.sort((a, b) => {
          return (this.layoutService.translateText(a.wardName)).localeCompare(this.layoutService.translateText(b.wardName));
        });
      });
    }
  }

  assignData(data) {
    data.Year = this.setyear;
    if (this.setInstitution != 0) {
      data.InstitutionIds = this.setInstitution.institutionID;
    }
    if (this.setFilterName)
      data.filterName = this.setFilterName;
    if (this.setWard != 0)
      data.WardId = this.setWard.wardID
    if (this.setDepartment != 0)
      data.DepartmentId = this.setDepartment.departmentID
    if (this.setDepartmentType != 0)
      data.DepartmentTypeId = this.setDepartmentType.departmentTypeID
    if (this.showMultiselect) {
      data.multiselect = true;
      data.multiSelectFilter = this.entrySelected.entryId;
      data.multiSelectName = this.entrySelected.name;
      data.multiSelectValues = this.entriesSelected.filter(entry => entry.selected).map(entry => { return { id: entry.entryId, name: entry.name } });
      this.exportMultiselect = {
        multiselect: data.multiselect,
        multiSelectFilter: data.multiSelectFilter,
        multiSelectValues: data.multiSelectValues
      }
    }
    return data
  }

  setSAFilter(filter, isManualUpdate = false) {
    let country = this.filtersService.countryList.find((list) => list.countryID == filter.CountryId);

    this.onCountryChange(country || 0, true).subscribe((institutions) => {
      if (institutions) {
        this.filtersService.filterInstitutions(institutions[0]);
        this.filtersService.institutionSubject.next(true);
        this.filtersService.getWardsByInstitutions();
      } else {
        this.filtersService.filterInstitutions([]);
        this.filtersService.institutionSubject.next(true);
        this.filtersService.getWardsByInstitutions();
      }
      this.setYear(filter.Year);
      this.setInstitutionsByID(filter.InstitutionIds, true);
      this.filtersService.wardListSubject.subscribe(loaded => {
        if (this.wardListLoaded && this.wardListLoaded.length > 0 && filter.WardId) {
          this.onWardChange(this.wardListLoaded.find(ward => ward.wardID == filter.WardId));
          this.setWard = this.ward;
        }
      });
      this.setDepartmentFilter(filter.DepartmentId, true);
      this.setDepartmentTypeFilter(filter.DepartmentTypeId, true);
      if (filter.Multiselect) {
        this.setMultiFilter(filter.Multiselect, filter.MultiSelectFilter, filter.MultiSelectValues, true);
      }
      this.layoutService.stopLoadingFilter();
    })

  }

  setYear(year) {
    if (year == 0) {
      year = this.currentYear;
    }
    this.setyear = year;
  }

  setCountryFilter(countryID, dummy, dummy2, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.countryList) {
      setCountry(isManualUpdate);
    }
    else {
      if (this.roleId == 1) {
        var countryListSubject1 = this.filtersService.countryListSubject.asObservable().subscribe(res => {
          countryListSubject1.unsubscribe();
          setCountry(isManualUpdate);
        })
      }
      else {
        self.setFilter(isManualUpdate);
      }
    }

    function setCountry(isManualUpdate = false) {
      if (self.filtersService.countryList.length > 0 && countryID !== 0) {
        self.country = self.filtersService.countryList.find((list) => list.countryID == countryID);
      } else {
        self.country = { countryName: self.layoutService.translateText('EVALUATION.All.COUNTRIES') };
      }

      self.setFilter(isManualUpdate);
    }
  }

  setDepartmentFilter(departmentId, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.departmentList) {
      setDepartment(isManualUpdate);
    } else {
      var subscriptionDepartmentList = this.filtersService.departmentListSubject.asObservable().subscribe(res => {
        subscriptionDepartmentList.unsubscribe();
        setDepartment(isManualUpdate);
      });
    }
    function setDepartment(isManualUpdate = false) {
      if (departmentId == "" || departmentId == 0) {
        self.department = { departmentName: self.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
      } else {
        if (self.filtersService.departmentList.length > 0) {
          self.department = self.filtersService.departmentList.find((res) => res.departmentID == departmentId);
          self.setFilter(isManualUpdate);
        }
      }
    }
  }

  setDepartmentTypeFilter(departmentTypeId, isManualUpdate = false) {
    var self = this;
    if (this.filtersService.departmentTypeList) {
      setDepartmentType(isManualUpdate);
    } else {
    }
    function setDepartmentType(isManualUpdate = false) {
      if (departmentTypeId == "" || departmentTypeId == 0) {
        self.departmentType = { departmentTypeName: self.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES') };
      } else {
        if (self.filtersService.departmentTypeList.length > 0) {
          self.departmentType = self.filtersService.departmentTypeList.find((res) => res.departmentTypeID == departmentTypeId);
          self.setFilter(isManualUpdate);
        }
      }
    }
  }

  setInstitutionsByID(InstitutionId, isManualUpdate = false) {
    var self = this;
    if (InstitutionId) {
      var tempArray = InstitutionId.toString().split(',')
      if (tempArray.length != 1) {
        return false;
      }
      if (this.roleId == 1) {
        this.institution = this.filtersService.institutionsList.find((list) => {
          return list.institutionID == InstitutionId
        });
        this.setFilter(isManualUpdate);
      } else {
        if (this.filtersService.institutionsList && this.filtersService.institutionsList.length > 0) {
          this.institution = this.filtersService.institutionsList.find((list) => list.institutionID == InstitutionId);
          this.setFilter(isManualUpdate);
        } else {
          this.filtersService.institutionSubject.subscribe(res => {
            this.institution = this.filtersService.institutionsList.find((list) => list.institutionID == InstitutionId);
            this.setFilter(isManualUpdate);
          })
        }
      }

      this.onInstitutionChange(this.institution, false);
    } else {
      this.institution = { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    }
  }

  setFilterNameFilter(filterName: string, isManualUpdate = false) {
    this.filterName = filterName;
    this.setFilterName = filterName;
    if (!isManualUpdate) {
      this.setFilter(isManualUpdate);
    }
  }

  isWardSelected() {
    return this.ward && this.ward.wardID && this.ward.wardID !== 0;
  }

  removeFilter() {
    this.filterRemoved.emit(this.filterIndex);
  }

  closeSidebarEvent(event) {
    this.singleCard = event.val;
    if (this.isNewFilter) {
      this.removeNewFilter();
      return;
    }
  }

  removeNewFilter() {
    if (this.filterIndex != 0) {
      this.removeFilter();
    } else {
      this.singleCard = false;
    }
  }

  compareDates(a, b) {
    return a.getFullYear() == b.getFullYear() && a.getMonth() == b.getMonth() && a.getDate() == b.getDate();
  }

  getActiveFilters() {
    var activeFilters = 0;
    if (this.setyear != this.currentYear) activeFilters++;
    if (this.roleId == 1 && this.country.countryName != this.layoutService.translateText('EVALUATION.All.COUNTRIES')) {
      activeFilters++;
    }

    if (this.institution.institutionName != this.layoutService.translateText('EVALUATION.All.INSTITUTIONS')) {
      activeFilters++;
    }

    if (this.ward.wardName != this.layoutService.translateText('EVALUATION.All.WARDS')) {
      activeFilters++;
    }

    if (this.department.departmentName != this.layoutService.translateText('EVALUATION.All.DEPARTMENTS')) {
      activeFilters++;
    }

    if (this.layoutService.translateText(this.departmentType.departmentTypeName) != this.layoutService.translateText('EVALUATION.All.DEPARTMENT_TYPES')) {
      activeFilters++;
    }

    if (this.entriesSelected) {
      activeFilters += this.entriesSelected.filter(entry => entry.entryId != -1 && entry.selected).length;
    }

    return activeFilters;
  }

  filterInstitutions(res: any[]): void {
    this.filtersService.institutionsList = res.filter((inst) => ((this.roleId > 2 ? inst.institution.institution.status : true)
      && (this.roleId <= 2 ? inst.institution.shareDataWithHartmann : true))).map((group) => group.institution);
  }

  setMultiFilter(multiselect, multiSelectFilter, multiSelectValues, isManualUpdate = false) {
    const self = this;
    if (multiselect) {
      this.showEntries = this.entriesList;
      this.showMultiselect = true;
      let entry = this.entriesList.find(entry => entry.entryId === multiSelectFilter);
      this.onEntryChange(entry);
      if(this.entriesSelected.length == 0) {
        var entriesSelectedSubscription = this.entriesSelectedSubject.asObservable().subscribe(res => {
          entriesSelectedSubscription.unsubscribe();
          loadMultifilter(entry);
        });
      }else{
        loadMultifilter(entry);
      }
    } else {
      this.entriesSelectedChips = [];
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();

    function loadMultifilter(entry){
      self.entriesSelected.forEach(e => e.selected = false);
        multiSelectValues.forEach(element => {
          let entry = self.entriesSelected.find(entry => entry.entryId === element.id) || {};
          entry.selected = true;
        });

        self.entriesSelectedChips = self.entriesSelected.filter(e => e.selected);
        self.setFilter(isManualUpdate);
        self.checkAllOrNothing();
        self.checkViewMoreButtonVisibility();
        self.updateSelectedEntriesCount();
    }
  }

  toggleMultiselect(evt: Event) {
    evt.stopPropagation();
    this.showEntries = this.entriesList;
    this.onEntryChange(this.entriesList[0]);
  }

  onEntryChange(entry) {
    this.entrySelected = entry;
    this.multiselectOption = this.layoutService.translateText(entry.name);
    this.entryNothingSelected = false;
    switch (entry.entryId) {
      case 'dept':
        if (this.filtersService.departmentList) {
          this.entriesSelected = [];
          this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentList.map((dept) => { return { entryId: dept.departmentID, name: dept.departmentName, selected: false } }));
          this.entriesSelected = this.entriesSelected.sort((a, b) => {
            return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
          });
          this.entriesSelectedSubject.next(true);
          // this.department = { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
        }else{
          var subscriptionDepartmentList = this.filtersService.departmentListSubject.asObservable().subscribe(res => {
            this.entriesSelected = [];
            this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentList.map((dept) => { return { entryId: dept.departmentID, name: dept.departmentName, selected: false } }));
            this.entriesSelected = this.entriesSelected.sort((a, b) => {
              return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
            });
            this.entriesSelectedSubject.next(true);
          })
        }
        break;
      case 'deptType':
        if (this.filtersService.departmentTypeList) {
          this.entriesSelected = [];
          this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentTypeList.map((deptType) => { return { entryId: deptType.departmentTypeID, name: deptType.departmentTypeName, selected: false } }));
          this.entriesSelected = this.entriesSelected.sort((a, b) => {
            return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
          });
          this.entriesSelectedSubject.next(true);
        }else{
          var subscriptionDepartmentTypeList = this.filtersService.departmentTypeListSubject.asObservable().subscribe(res => {
            this.entriesSelected = [];
            this.entriesSelected = this.entriesSelected.concat(this.filtersService.departmentTypeList.map((deptType) => { return { entryId: deptType.departmentTypeID, name: deptType.departmentTypeName, selected: false } }));
            this.entriesSelected = this.entriesSelected.sort((a, b) => {
              return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
            });
            this.entriesSelectedSubject.next(true);
          });
        }
        break;
      case 'ward':
        if (this.filtersService.wardList) {
          this.loadMultiFilterWards();
        }else{
          var subscriptionWardList = this.filtersService.wardListSubject.asObservable().subscribe(res => {
            this.loadMultiFilterWards();
          });
        }
        break;
    }

    this.entriesSelectedChips = [];
    this.checkAllOrNothing();
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
  }

  loadMultiFilterWards() {
    if (this.entrySelected.entryId == 'ward') {
      this.entriesSelected = [];
      if (this.setInstitution) {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.wardList.filter(ward => ward.institutionID == this.institution.institutionID).map((ward) => { return { entryId: ward.wardID, name: ward.wardName, selected: false } }));
      } else {
        this.entriesSelected = this.entriesSelected.concat(this.filtersService.wardList.map((ward) => { return { entryId: ward.wardID, name: ward.wardName, selected: false } }));
      }

      this.entriesSelected = this.entriesSelected.sort((a, b) => {
        return (this.layoutService.translateText(a.name)).localeCompare(this.layoutService.translateText(b.name));
      });
      this.entriesSelectedSubject.next(true);

    }
  }

  toggleEntry(evt: Event, entry) {
    evt.stopPropagation();
    evt.preventDefault();

    this.checkAllOrNothing();
    this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected);
    this.updateSelectedEntriesCount();
    this.checkViewMoreButtonVisibility();
  }

  updateSelectedEntriesCount(): void {
    this.selectedEntriesCount = this.entriesSelected.filter(e => e.selected).length;
  }

  getEntriesSelected() {
    let selection = this.entriesSelected.filter(e => e.selected);
    if (selection.length > 0) {
      this.entryNothingSelected = false;
      return selection;
    } else {
      this.entryNothingSelected = true;
      return [];
    }
  }

  deselectEntry(evt: Event, entry, evaluate = false) {
    evt.stopPropagation();
    entry.selected = false;
    this.checkAllOrNothing();
    if (evaluate) {
      this.setFilter();
    } else {
      this.entriesSelectedChips = this.entriesSelected.filter(e => e.selected );
    }
    this.checkViewMoreButtonVisibility();
    this.updateSelectedEntriesCount();
  }

  checkAllOrNothing() {
    this.entryNothingSelected = false;
    // this.allEntriesChecked = true;
    // this.entriesSelected.forEach((e, index) => {
    //   if (index > 0) {
    //     if (!e.selected) {
    //     }
    //   }
    // });
    this.entryNothingSelected = this.entriesSelected.every(e => !e.selected);

  }

  multiSelectRemoved() {
    this.showMultiselect = false;
    this.entriesSelected = [];
    this.entriesSelectedChips = [];
  }

  showMultiselectChip(entryId) {
    return !this.showMultiselect || (this.showMultiselect && this.entrySelected.entryId != entryId);
  }

  async checkViewMoreButtonVisibility() {
    setTimeout(() => {
      this.lessMoreIsVisible = false;
      if (this.chipsDiv.nativeElement.offsetHeight > 70) {
        this.lessMoreIsVisible = true;
        this.viewMore = false;
      }
    }, 50);
  }

  onResize(event) {
    this.checkViewMoreButtonVisibility();
  }
}
